import request from '#/utils/request';
import { parseVer4TreeResponse } from '#/api/adapters/envelope';

/**
 * 檢測種類列表沒有 page，envelope 是 { message, route, list }。
 */
export async function fetchInspectionKindList() {
  const { data: raw } = await request.get('/ims/inspection-kinds');
  return parseVer4TreeResponse(raw);
}
